import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors } from "@styles";

export const link = css`
  font-weight: ${typography.weightSemiBold};
  color: ${colors.green.base};

  &:hover {
    color: ${colors.green.darkFamily.light};
  }
`;
